import { matchRoutes, useLocation } from 'react-router-dom';

export const useMatchRoutes = (routes: string[]): boolean => {
  const location = useLocation();
  const arrOfRouteObjects = routes.map((pathString) => Object.create({}, { path: { value: pathString } }));
  const matchedRoute = matchRoutes(arrOfRouteObjects, location.pathname)?.length;

  return Boolean(matchedRoute);
};
